import { type ReactNode } from 'react';
import type { TierDraft } from '../utils/group-tier-helpers';
import type { TierFieldErrors } from '../utils/validate-group-tiers';
import { GroupTierRow } from './group-tier-row';

type Props = {
  tiers: TierDraft[];
  errors: TierFieldErrors;
  onUpdate: (i: number, t: TierDraft) => void;
  onRemove: (i: number) => void;
};

function rowProps(p: Props, i: number) {
  const last = p.tiers.length - 1;
  return {
    id: p.tiers[i]!.id,
    tier: p.tiers[i]!,
    isFirst: i === 0,
    isLast: i === last,
    canRemove: p.tiers.length > 1,
    rangeError: p.errors.range.has(i),
    amountError: p.errors.amount.has(i),
  };
}

export function GroupTierRows(p: Props): ReactNode {
  return (
    <div className="space-y-0.5">
      {p.tiers.map((t, i) => (
        <GroupTierRow
          key={t.id}
          {...rowProps(p, i)}
          onChange={(updated) => p.onUpdate(i, updated)}
          onRemove={() => p.onRemove(i)}
        />
      ))}
    </div>
  );
}
